import Vue from 'vue'
import Router from 'vue-router'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
import Layout from '../views/admin/layout/Layout'

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/
export const constantRouterMap = [
  { path: '/forgot', component: () => import('@/views/forgot/index'), hidden: true },
  { path: '/response/:email', component: () => import('@/views/forgot/response'), hidden: true },
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/registerindividual', component: () => import('@/views/login/registerindividual'), hidden: true },
  { path: '/registercompany', component: () => import('@/views/login/registercompany'), hidden: true },
  { path: '/registercorporation', component: () => import('@/views/login/registercorporation'), hidden: true },
  // { path: '/register', component: () => import('@/views/register/index'), hidden: true },
  { path: '/reset', component: () => import('@/views/forgot/reset'), hidden: true },
  { path: '/success', component: () => import('@/views/forgot/success'), hidden: true },
  { path: '/faq', component: () => import('@/views/faq/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  { path: '', component: () => import('@/views/home/index'), hidden: true },
  { path: '/semak_kenderaan', component: () => import('@/views/home/semakkenderaan'), hidden: true },
  { path: '/pengenalan', component: () => import('@/views/home/pengenalan'), hidden: true },
  { path: '/cara_memohon', component: () => import('@/views/home/caramemohon'), hidden: true },
  { path: '/syarat_kelayakan', component: () => import('@/views/home/syaratkelayakan'), hidden: true },
  { path: '/hubungi_kami', component: () => import('@/views/home/hubungikami'), hidden: true },
  // { path: '/landingpagepart3', component: () => import('@/views/home/oldlandingpagepart3base'), hidden: true },
  // { path: '/v1', component: () => import('@/views/home/oldlandingpagepart3base'), hidden: true },
  // { path: '/v1', component: () => import('@/views/home/v1'), hidden: true },
  // { path: '/v2', component: () => import('@/views/home/oldindex'), hidden: true },
  // { path: '/framerv2', component: () => import('@/views/home/newlandingpagev2combined'), hidden: true },
  // { path: '/v3', component: () => import('@/views/home/v3'), hidden: true },
  // { path: '/v4', component: () => import('@/views/home/v4'), hidden: true },
  { path: '/confirmation', component: () => import('@/views/home/confirmation'), hidden: true },
  { path: '/confirmation-success', component: () => import('@/views/home/confirmation-success'), hidden: true },
  // { path: '/legal', component: () => import('@/views/legal/legal-replacement'), hidden: true },
  // { path: '/privacy', component: () => import('@/views/legal/privacy-replacement'), hidden: true },
  // { path: '/cookie', component: () => import('@/views/legal/cookie-replacement'), hidden: true },
  { path: '/unconfirmed', component: () => import('@/views/unconfirmed/index'), hidden: true },
]

export default new Router({
  // mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
  mode: 'history'
})

export const unconfirmedRouterMap = [
  { path: '/dashboard', component: () => import('@/views/unconfirmed/index'), hidden: true }
]

export const rejectedRouterMap = [
  { path: '/dashboard', component: () => import('@/views/unconfirmed/rejected'), hidden: true }
]

export const adminWaitingRouterMap = [
  { path: '/z/:branchId/default', component: () => import('@/views/unconfirmed/adminwaiting'), hidden: true },
]

export const asyncRouterMap = [
  /*   ========  ========  ======== */
  /*  ======== MY PETROL ======== */
  /* ========  ========  ======== */
  // {-
  {
    path: '/z/:branchId/mypetrol/halamanutama',
    component: Layout,
    redirect: '',
    name: 'Profil',
    meta: { relationRoles: ['Owner'], feature: 'mypetrol', title: 'MyPetrol' },
    children: [
      {
        path: '',
        component: () => import('@/views/mypetrol/profil_petrol'),
        meta: { title: 'Profil' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/fleetcard',
    component: Layout,
    redirect: '',
    name: 'Fleet Card',
    meta: { relationRoles: ['Owner'], feature: 'mypetrol', title: 'Fleet Card' },
    children: [
      {
        path: 'maklumatfleetcardsemasa',
        component: () => import('@/views/mypetrol/maklumatfleetcardsemasa_petrol'),
        meta: { title: 'Maklumat Fleet Card Semasa' }
      },
      // {
      //   path: 'permohonantambahkenderaan',
      //   component: () => import('@/views/mypetrol/permohonantambahkenderaan_petrol'),
      //   meta: { title: 'Permohonan Tambah Kenderaan' }
      // },
      {
        path: 'tambahkenderaan',
        component: () => import('@/views/mypetrol/tambahkenderaan_petrol'),
        meta: { title: 'Tambah Kenderaan' },
        hidden: true
      },
      {
        path: 'mulatambahkenderaan',
        component: () => import('@/views/mypetrol/mulatambahkenderaan_petrol'),
        meta: { title: 'Tambah Kenderaan' },
        hidden: true
      },
      {
        path: 'mulatambahsyarikatminyak',
        component: () => import('@/views/mypetrol/mulatambahsyarikatminyak_petrol'),
        meta: { title: 'Tambah Syarikat Minyak' },
        hidden: true
      },
      // {
      //   path: 'permohonantambahkenderaan-duplicate',
      //   component: () => import('@/views/mypetrol/permohonantambahkenderaan-duplicate'),
      //   meta: { title: 'DUPLICATE Permohonan Tambah Kenderaan' }
      // },
      // {
      //   path: 'testfile',
      //   component: () => import('@/views/mypetrol/testfile'),
      //   meta: { title: 'Testfile' }
      // },
      {
        path: 'senaraifleetcard',
        component: () => import('@/views/mypetrol/senaraifleetcard_petrol'),
        meta: { title: 'Senarai Fleet Card' }
      },
      {
        path: 'permohonanpertukaransyarikatminyak',
        component: () => import('@/views/mypetrol/permohonanpertukaransyarikatminyak_petrol'),
        meta: { title: 'Permohonan Pertukaran Syarikat Minyak' }
      },
      // {
      //   path: 'rayuan',
      //   component: () => import('@/views/mypetrol/rayuan_petrol'),
      //   meta: { title: 'Rayuan' },
      // },
      {
        path: 'keduatukarsyarikatminyak',
        component: () => import('@/views/mypetrol/keduatukarsyarikatminyak_petrol'),
        meta: { title: 'Tukar Syarikat Minyak' },
        hidden: true
      },
    ],
    noCollapse: true,
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/halamanutama',
    component: Layout,
    redirect: '',
    name: 'Halaman Utama',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Halaman Utama' },
    children: [
      // {
      //   path: 'kpdndashboard',
      //   component: () => import('@/views/mypetrol/kpdndashboard_petrol'),
      //   meta: { title: 'Halaman Utama' },
      //   hidden: true
      // },
      {
        path: 'dashboardduplicate_petrol',
        component: () => import('@/views/mypetrol/dashboardduplicate_petrol'),
        meta: { title: 'Halaman Utama Hidden' },
        hidden: true
      },
      {
        path: '',
        component: () => import('@/views/mypetrol/dashboardduplicate_petrol2'),
        meta: { title: 'Halaman Utama' },
        // hidden: true
      },
      {
        path: 'map',
        component: () => import('@/views/mypetrol/map_petrol'),
        meta: { title: '[DEV] Map' },
        hidden: true
      },
      {
        path: 'analisis',
        component: () => import('@/views/mypetrol/analisis_petrol'),
        meta: { title: 'Analisis' },
        // hidden: true
      },
      {
        path: 'analisis2',
        component: () => import('@/views/mypetrol/analisis_petrol2'),
        meta: { title: 'Analisis2' },
        hidden: true
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/pengguna',
    component: Layout,
    redirect: '',
    name: 'Pengguna',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Pengguna' },
    children: [
      {
        path: 'senaraipengguna',
        component: () => import('@/views/mypetrol/senaraipengguna_petrol'),
        meta: { title: 'Pengguna Awam' }
      },
      // {
      //   path: 'senaraikementerian',
      //   component: () => import('@/views/mypetrol/senaraikementerian_petrol'),
      //   meta: { title: 'Pengguna Dalaman KPDN' }
      // },
      // {
      //   path: 'senaraiagensi',
      //   component: () => import('@/views/mypetrol/senaraiagensi_petrol'),
      //   meta: { title: 'Pengguna Agensi' }
      // },
      {
        path: 'senaraisyarikatminyak',
        component: () => import('@/views/mypetrol/senaraisyarikatminyak_petrol'),
        meta: { title: 'Pengguna Syarikat Minyak' },
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/admin',
    component: Layout,
    redirect: '',
    name: 'Fleet Card',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Fleet Card' },
    children: [
      {
        path: 'pemegangakaun',
        component: () => import('@/views/mypetrol/pemegangakaun_petrol'),
        meta: { title: 'Pemegang Akaun' }
      },
      {
        path: 'physicalfleetcard',
        component: () => import('@/views/mypetrol/physicalfleetcardadmin_petrol'),
        meta: { title: 'Senarai Fleet Card' }
      },
      // {
      //   path: 'kuota_tambahan',
      //   component: () => import('@/views/mypetrol/kuota_tambahan_petrol'),
      //   meta: { title: 'Kuota Tambahan' }
      // },
      // {
      //   path: 'pembatalan_kuota',
      //   component: () => import('@/views/mypetrol/pembatalan_kuota_petrol'),
      //   meta: { title: 'Pembatalan Kuota' }
      // },
      {
        path: 'pertukaransyarikatminyak',
        component: () => import('@/views/mypetrol/pertukaransyarikatminyak_petrol'),
        meta: { title: 'Pertukaran Syarikat Minyak' },
      },
      {
        path: 'rayuan',
        component: () => import('@/views/mypetrol/fleetcardvehicleappeals_petrol'),
        meta: { title: 'Rayuan' }
      },
      {
        path: 'kuotatambahan',
        component: () => import('@/views/mypetrol/kuotatambahan_petrol'),
        meta: { title: 'Kuota Tambahan' }
      },
    ],
    branch: true
  },
  // {
  //   path: '/z/:branchId/mypetrol/rayuan',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Rayuan',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Rayuan' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/mypetrol/fleetcardvehicleappeals_petrol'),
  //       meta: { title: 'Rayuan' }
  //     }
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/mypetrol/system',
    component: Layout,
    redirect: '',
    name: 'Pengurusan Sistem',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Pengurusan Sistem' },
    children: [
      // {
      //   path: 'menu_kuota_tambahan',
      //   component: () => import('@/views/mypetrol/halamanutama_petrol'),
      //   meta: { title: 'Tetapan Menu Kuota Tambahan' },
      // },
      // {
      //   path: 'tetapanrekodpenggunaan',
      //   component: () => import('@/views/mypetrol/tetapanrekodpenggunaan_petrol'),
      //   meta: { title: 'Tetapan Rekod Penggunaan Kuota' },
      // },
      // {
      //   path: 'detailrekodpenggunaan',
      //   component: () => import('@/views/mypetrol/detailrekodpenggunaan_petrol'),
      //   meta: { title: 'Detail - Rekod Penggunaan Kuota' },
      // },
      // {
      //   path: 'oilcompanies',
      //   component: () => import('@/views/codestructor/oilcompanies_petrol'),
      //   meta: { title: 'Tetapan Syarikat Minyak' },
      // },
      {
        path: 'tetapanjenisbadan',
        component: () => import('@/views/mypetrol/tetapanjenisbadan_petrol'),
        meta: { title: 'Tetapan Jenis Badan' },
      },
      {
        path: 'tetapanjeniskegunaan',
        component: () => import('@/views/mypetrol/tetapanjeniskegunaan_petrol'),
        meta: { title: 'Tetapan Kelas Kegunaan' },
      },
      {
        path: 'dashboardtetapanjenisbadan',
        component: () => import('@/views/mypetrol/dashboardtetapanjenisbadan_petrol'),
        meta: { title: 'Tetapan Deskripsi Umum (Halaman Utama)' },
      },
      // {
      //   path: 'kandungan_portal',
      //   component: () => import('@/views/mypetrol/kandunganportal_petrol'),
      //   meta: { title: 'Kandungan Portal' },
      // },
      // {
      //   path: 'kandunganbanner',
      //   component: () => import('@/views/mypetrol/kandunganbanner_petrol'),
      //   meta: { title: 'Kandungan Banner' },
      // },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/sekatan',
    component: Layout,
    redirect: '',
    name: 'Sekatan',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Sekatan' },
    children: [
      {
        path: 'senaraisekatan',
        component: () => import('@/views/mypetrol/senaraisekatan_petrol'),
        meta: { title: 'Senarai Sekatan' }
      },
      // {
      //   path: 'sejarahsekatan',
      //   component: () => import('@/views/mypetrol/sejarahsekatan_petrol'),
      //   meta: { title: 'Sejarah Sekatan' }
      // },
    ],
    alwaysShow: true,
    branch: true
  },
  // {
  //   path: '/z/:branchId/mypetrol/carian',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Carian',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Carian Pemegang Akaun atau Kenderaan' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/mypetrol/halamanutama_petrol'),
  //       meta: { title: 'Carian Pemegang Akaun atau Kenderaan' }
  //     },
  //   ],
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/mypetrol/admin',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Admin',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Admin' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/mypetrol/halamanutama_petrol'),
  //       meta: { title: 'Admin' }
  //     },
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/mypetrol/search',
    component: Layout,
    redirect: '',
    name: 'Carian',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Carian' },
    children: [
      {
        path: 'jpj',
        component: () => import('@/views/mypetrol/searchjpj_petrol'),
        meta: { title: 'Rekod Kenderaan' },
      },
      {
        path: 'ssm',
        component: () => import('@/views/mypetrol/searchssm_petrol'),
        meta: { title: 'Semakan Data Syarikat' },
      },
      {
        path: 'jpn',
        component: () => import('@/views/mypetrol/searchjpn_petrol'),
        meta: { title: 'Semakan Data Pemilikan Tunggal' },
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/laporan',
    component: Layout,
    redirect: '',
    name: 'Laporan',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Laporan' },
    children: [
      {
        path: '',
        component: () => import('@/views/mypetrol/laporan_petrol'),
        meta: { title: 'Laporan' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/kpdnprofil',
    component: Layout,
    redirect: '',
    name: 'Profil',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Profil' },
    children: [
      {
        path: '',
        component: () => import('@/views/mypetrol/kpdnprofil_petrol'),
        meta: { title: 'Profil' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/systemsettings',
    component: Layout,
    redirect: '',
    name: 'Tetapan Sistem',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Tetapan Sistem' },
    children: [
      {
        path: '',
        component: () => import('@/views/mypetrol/systemsettings_petrol'),
        meta: { title: 'Tetapan Sistem' },
        hidden: true
      },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/manual',
    component: Layout,
    redirect: '',
    name: 'Manual',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Manual' },
    children: [
      {
        path: 'manualpegawai',
        component: () => import('@/views/mypetrol/blank_petrol'),
        meta: { title: 'Manual Pegawai' },
      },
      {
        path: 'manualpengguna',
        component: () => import('@/views/mypetrol/blank_petrol'),
        meta: { title: 'Manual Pengguna' },
      },
    ],
    branch: true
  },
  // {
  //   path: '/z/:branchId/mypetrol/testing',
  //   component: Layout,
  //   redirect: '',
  //   name: 'TESTING',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'TESTING' },
  //   children: [
  //     {
  //       path: 'testingssmcompanies',
  //       component: () => import('@/views/mypetrol/testingssmcompanies_petrol'),
  //       meta: { title: 'SSM Companies' },
  //     },
  //     {
  //       path: 'testingjpjcompanies',
  //       component: () => import('@/views/mypetrol/testingjpjcompanies_petrol'),
  //       meta: { title: 'JPJ Companies' },
  //     },
  //     {
  //       path: 'testingjpjvehicles',
  //       component: () => import('@/views/mypetrol/testingjpjvehicles_petrol'),
  //       meta: { title: 'JPJ Vehicles' },
  //     },
  //     {
  //       path: 'testingmyidentityindividuals',
  //       component: () => import('@/views/mypetrol/testingmyidentityindividuals_petrol'),
  //       meta: { title: 'myIDENTITY Individuals' },
  //     },
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/mypetrol/halamanutama',
    component: Layout,
    redirect: '',
    name: 'Halaman Utama',
    meta: { relationRoles: ['oilcompanyuser'], feature: 'mypetrol', title: 'MyPetrol' },
    children: [
      {
        path: '',
        component: () => import('@/views/mypetrol/halamanutamaoilcompany_petrol'),
        meta: { title: 'Halaman Utama' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol',
    component: Layout,
    redirect: '',
    name: 'Fleet Card',
    meta: { relationRoles: ['oilcompanyuser'], feature: 'mypetrol', title: 'Fleet Card' },
    children: [
      {
        path: 'pemegangakaun',
        component: () => import('@/views/mypetrol/pemegangakaunoilcompany_petrol'),
        meta: { title: 'Pemegang Akaun' }
      },
      {
        path: 'physicalfleetcard',
        component: () => import('@/views/mypetrol/physicalfleetcardoilcompany_petrol'),
        meta: { title: 'Senarai Fleet Card' }
      },
      {
        path: 'permohonanpertukaransyarikatminyak',
        component: () => import('@/views/mypetrol/permohonanpertukaransyarikatminyakoilcompany_petrol'),
        meta: { title: 'Permohonan Pertukaran Syarikat Minyak' }
      },
    ],
    noCollapse: true,
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/rekodpenggunaan',
    component: Layout,
    redirect: '',
    name: 'Laporan',
    meta: { relationRoles: ['oilcompanyuser'], feature: 'mypetrol', title: 'Laporan' },
    children: [
      // {
      //   path: 'rekodpenggunaan',
      //   component: () => import('@/views/mypetrol/rekodpenggunaanoilcompany'),
      //   meta: { title: 'Rekod Penggunaan' }
      // },
      {
        path: 'detailrekodpenggunaanoilcompany',
        component: () => import('@/views/mypetrol/detailrekodpenggunaanoilcompany'),
        meta: { title: 'Laporan Penggunaan Kuota' }
      },
      {
        path: 'detailmonthquotaoilcompany',
        component: () => import('@/views/mypetrol/detailmonthquotaoilcompany'),
        meta: { title: 'Laporan Pemegang Akaun' }
      },
      {
        path: 'kuotatambahan',
        component: () => import('@/views/mypetrol/kuotatambahanoilcompany_petrol'),
        meta: { title: 'Laporan Kuota Tambahan' }
      },
      // {
      //   path: 'percentagechangesoilcompany',
      //   component: () => import('@/views/mypetrol/percentagechangesoilcompany'),
      //   meta: { title: 'Laporan Perubahan Kuota' }
      // },
    ],
    noCollapse: true,
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/sekatan',
    component: Layout,
    redirect: '',
    name: 'Sekatan',
    meta: { relationRoles: ['oilcompanyuser'], feature: 'mypetrol', title: 'Sekatan' },
    children: [
      {
        path: 'senaraisekatan',
        component: () => import('@/views/mypetrol/senaraisekatanoilcompany_petrol'),
        meta: { title: 'Senarai Sekatan' }
      },
    ],
    noCollapse: true,
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/banner',
    component: Layout,
    redirect: '',
    name: 'Senarai Banner',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Banner' },
    children: [
      {
        path: 'senaraibanner',
        component: () => import('@/views/mypetrol/senaraibanner_petrol'),
        meta: { title: 'Senarai Banner' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/halamanutama',
    component: Layout,
    redirect: '',
    name: 'Sekatan',
    meta: { relationRoles: ['enforcer'], feature: 'mypetrol', title: 'Sekatan' },
    children: [
      {
        path: '',
        component: () => import('@/views/mypetrol/senaraisekatan_petrol'),
        meta: { title: 'Senarai Sekatan' }
      },
    ],
    noCollapse: true,
    alwaysShow: true,
    branch: true
  },

  /*   ========  ========  ======== */
  /*  ======== MY DIESEL ======== */
  /* ========  ========  ======== */
  {
    path: '/z/:branchId/mydiesel/halamanutama',
    component: Layout,
    redirect: '',
    name: 'Profil',
    meta: { relationRoles: ['Owner'], feature: 'mydiesel', title: 'MyDiesel' },
    children: [
      {
        path: '',
        component: () => import('@/views/mydiesel/profil_diesel'),
        meta: { title: 'Profil' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/fleetcard',
    component: Layout,
    redirect: '',
    name: 'Fleet Card',
    meta: { relationRoles: ['Owner'], feature: 'mydiesel', title: 'Fleet Card' },
    children: [
      {
        path: 'maklumatfleetcardsemasa',
        component: () => import('@/views/mydiesel/maklumatfleetcardsemasa_diesel'),
        meta: { title: 'Maklumat Fleet Card Semasa' }
      },
      // {
      //   path: 'permohonantambahkenderaan',
      //   component: () => import('@/views/mydiesel/permohonantambahkenderaan_diesel'),
      //   meta: { title: 'Permohonan Tambah Kenderaan' }
      // },
      {
        path: 'tambahkenderaan',
        component: () => import('@/views/mydiesel/tambahkenderaan_diesel'),
        meta: { title: 'Tambah Kenderaan' },
        hidden: true
      },
      {
        path: 'mulatambahkenderaan',
        component: () => import('@/views/mydiesel/mulatambahkenderaan_diesel'),
        meta: { title: 'Tambah Kenderaan' },
        hidden: true
      },
      {
        path: 'mulatambahsyarikatminyak',
        component: () => import('@/views/mydiesel/mulatambahsyarikatminyak_diesel'),
        meta: { title: 'Tambah Syarikat Minyak' },
        hidden: true
      },
      // {
      //   path: 'permohonantambahkenderaan-duplicate',
      //   component: () => import('@/views/mydiesel/permohonantambahkenderaan-duplicate'),
      //   meta: { title: 'DUPLICATE Permohonan Tambah Kenderaan' }
      // },
      // {
      //   path: 'testfile',
      //   component: () => import('@/views/mydiesel/testfile'),
      //   meta: { title: 'Testfile' }
      // },
      {
        path: 'senaraifleetcard',
        component: () => import('@/views/mydiesel/senaraifleetcard_diesel'),
        meta: { title: 'Senarai Fleet Card' }
      },
      {
        path: 'permohonanpertukaransyarikatminyak',
        component: () => import('@/views/mydiesel/permohonanpertukaransyarikatminyak_diesel'),
        meta: { title: 'Permohonan Pertukaran Syarikat Minyak' }
      },
      // {
      //   path: 'rayuan',
      //   component: () => import('@/views/mydiesel/rayuan_diesel'),
      //   meta: { title: 'Rayuan' },
      // },
      {
        path: 'keduatukarsyarikatminyak',
        component: () => import('@/views/mydiesel/keduatukarsyarikatminyak_diesel'),
        meta: { title: 'Tukar Syarikat Minyak' },
        hidden: true
      },
    ],
    noCollapse: true,
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/halamanutama',
    component: Layout,
    redirect: '',
    name: 'Halaman Utama',
    meta: { relationRoles: ['kpdnadmin', 'enforcer'], feature: 'mydiesel', title: 'Halaman Utama' },
    children: [
      // {
      //   path: 'kpdndashboard',
      //   component: () => import('@/views/mydiesel/kpdndashboard_diesel'),
      //   meta: { title: 'Halaman Utama' },
      //   hidden: true
      // },
      {
        path: 'dashboardduplicate_diesel',
        component: () => import('@/views/mydiesel/dashboardduplicate_diesel'),
        meta: { title: 'Halaman Utama Hidden' },
        hidden: true
      },
      {
        path: '',
        component: () => import('@/views/mydiesel/dashboardduplicate_diesel2'),
        meta: { title: 'Halaman Utama' },
        // hidden: true
      },
      {
        path: 'map',
        component: () => import('@/views/mydiesel/map_diesel'),
        meta: { title: '[DEV] Map' },
        hidden: true
      },
      {
        path: 'analisis',
        component: () => import('@/views/mydiesel/analisis_diesel'),
        meta: { title: 'Analisis' },
        // hidden: true
      },
      {
        path: 'analisis2',
        component: () => import('@/views/mydiesel/analisis_diesel2'),
        meta: { title: 'Analisis2' },
        hidden: true
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/pengguna',
    component: Layout,
    redirect: '',
    name: 'Pengguna',
    meta: { relationRoles: ['kpdnadmin', 'enforcer'], feature: 'mydiesel', title: 'Pengguna' },
    children: [
      {
        path: 'senaraipengguna',
        component: () => import('@/views/mydiesel/senaraipengguna_diesel'),
        meta: { title: 'Pengguna Awam' }
      },
      // {
      //   path: 'senaraikementerian',
      //   component: () => import('@/views/mydiesel/senaraikementerian_diesel'),
      //   meta: { title: 'Pengguna Dalaman KPDN' }
      // },
      // {
      //   path: 'senaraiagensi',
      //   component: () => import('@/views/mydiesel/senaraiagensi_diesel'),
      //   meta: { title: 'Pengguna Agensi' }
      // },
      {
        path: 'senaraisyarikatminyak',
        component: () => import('@/views/mydiesel/senaraisyarikatminyak_diesel'),
        meta: { title: 'Pengguna Syarikat Minyak' },
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/admin',
    component: Layout,
    redirect: '',
    name: 'Fleet Card',
    meta: { relationRoles: ['kpdnadmin', 'enforcer'], feature: 'mydiesel', title: 'Fleet Card' },
    children: [
      {
        path: 'pemegangakaun',
        component: () => import('@/views/mydiesel/pemegangakaun_diesel'),
        meta: { title: 'Pemegang Akaun' }
      },
      {
        path: 'physicalfleetcard',
        component: () => import('@/views/mydiesel/physicalfleetcardadmin_diesel'),
        meta: { title: 'Senarai Fleet Card' }
      },
      // {
      //   path: 'kuota_tambahan',
      //   component: () => import('@/views/mydiesel/kuota_tambahan_diesel'),
      //   meta: { title: 'Kuota Tambahan' }
      // },
      // {
      //   path: 'pembatalan_kuota',
      //   component: () => import('@/views/mydiesel/pembatalan_kuota_diesel'),
      //   meta: { title: 'Pembatalan Kuota' }
      // },
      {
        path: 'pertukaransyarikatminyak',
        component: () => import('@/views/mydiesel/pertukaransyarikatminyak_diesel'),
        meta: { title: 'Pertukaran Syarikat Minyak' },
      },
      {
        path: 'rayuan',
        component: () => import('@/views/mydiesel/fleetcardvehicleappeals_diesel'),
        meta: { title: 'Rayuan' }
      },
      {
        path: 'kuotatambahan',
        component: () => import('@/views/mydiesel/kuotatambahan_diesel'),
        meta: { title: 'Kuota Tambahan' }
      },
    ],
    branch: true
  },
  // {
  //   path: '/z/:branchId/mydiesel/rayuan',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Rayuan',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'Rayuan' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/mydiesel/fleetcardvehicleappeals_diesel'),
  //       meta: { title: 'Rayuan' }
  //     }
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/mydiesel/system',
    component: Layout,
    redirect: '',
    name: 'Pengurusan Sistem',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'Pengurusan Sistem' },
    children: [
      // {
      //   path: 'menu_kuota_tambahan',
      //   component: () => import('@/views/mydiesel/halamanutama_diesel'),
      //   meta: { title: 'Tetapan Menu Kuota Tambahan' },
      // },
      // {
      //   path: 'tetapanrekodpenggunaan',
      //   component: () => import('@/views/mydiesel/tetapanrekodpenggunaan_diesel'),
      //   meta: { title: 'Tetapan Rekod Penggunaan Kuota' },
      // },
      // {
      //   path: 'detailrekodpenggunaan',
      //   component: () => import('@/views/mydiesel/detailrekodpenggunaan_diesel'),
      //   meta: { title: 'Detail - Rekod Penggunaan Kuota' },
      // },
      // {
      //   path: 'oilcompanies',
      //   component: () => import('@/views/codestructor/oilcompanies_diesel'),
      //   meta: { title: 'Tetapan Syarikat Minyak' },
      // },
      {
        path: 'tetapanjenisbadan',
        component: () => import('@/views/mydiesel/tetapanjenisbadan_diesel'),
        meta: { title: 'Tetapan Jenis Badan' },
      },
      {
        path: 'tetapanjeniskegunaan',
        component: () => import('@/views/mydiesel/tetapanjeniskegunaan_diesel'),
        meta: { title: 'Tetapan Kelas Kegunaan' },
      },
      {
        path: 'dashboardtetapanjenisbadan',
        component: () => import('@/views/mydiesel/dashboardtetapanjenisbadan_diesel'),
        meta: { title: 'Tetapan Deskripsi Umum (Dashboard)' },
      },
      // {
      //   path: 'kandungan_portal',
      //   component: () => import('@/views/mydiesel/kandunganportal_diesel'),
      //   meta: { title: 'Kandungan Portal' },
      // },
      // {
      //   path: 'kandunganbanner',
      //   component: () => import('@/views/mydiesel/kandunganbanner_diesel'),
      //   meta: { title: 'Kandungan Banner' },
      // },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/sekatan',
    component: Layout,
    redirect: '',
    name: 'Sekatan',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'Sekatan' },
    children: [
      {
        path: 'senaraisekatan',
        component: () => import('@/views/mydiesel/senaraisekatan_diesel'),
        meta: { title: 'Senarai Sekatan' }
      },
      // {
      //   path: 'sejarahsekatan',
      //   component: () => import('@/views/mydiesel/sejarahsekatan_diesel'),
      //   meta: { title: 'Sejarah Sekatan' }
      // },
    ],
    alwaysShow: true,
    branch: true
  },
  // {
  //   path: '/z/:branchId/mydiesel/carian',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Carian',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'Carian Pemegang Akaun atau Kenderaan' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/mydiesel/halamanutama_diesel'),
  //       meta: { title: 'Carian Pemegang Akaun atau Kenderaan' }
  //     },
  //   ],
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/mydiesel/admin',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Admin',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'Admin' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/mydiesel/halamanutama_diesel'),
  //       meta: { title: 'Admin' }
  //     },
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/mydiesel/search',
    component: Layout,
    redirect: '',
    name: 'Carian',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'Carian' },
    children: [
      {
        path: 'jpj',
        component: () => import('@/views/mydiesel/searchjpj_diesel'),
        meta: { title: 'Rekod Kenderaan' },
      },
      {
        path: 'ssm',
        component: () => import('@/views/mydiesel/searchssm_diesel'),
        meta: { title: 'Semakan Data Syarikat' },
      },
      {
        path: 'jpn',
        component: () => import('@/views/mydiesel/searchjpn_diesel'),
        meta: { title: 'Semakan Data Pemilikan Tunggal' },
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/laporan',
    component: Layout,
    redirect: '',
    name: 'Laporan',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'Laporan' },
    children: [
      {
        path: '',
        component: () => import('@/views/mydiesel/laporan_diesel'),
        meta: { title: 'Laporan' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/kpdnprofil',
    component: Layout,
    redirect: '',
    name: 'Profil',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'Profil' },
    children: [
      {
        path: '',
        component: () => import('@/views/mydiesel/kpdnprofil_diesel'),
        meta: { title: 'Profil' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/systemsettings',
    component: Layout,
    redirect: '',
    name: 'Tetapan Sistem',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'Tetapan Sistem' },
    children: [
      {
        path: '',
        component: () => import('@/views/mydiesel/systemsettings_diesel'),
        meta: { title: 'Tetapan Sistem' },
        hidden: true
      },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/manual',
    component: Layout,
    redirect: '',
    name: 'Manual',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'Manual' },
    children: [
      {
        path: 'manualpegawai',
        component: () => import('@/views/mydiesel/blank_diesel'),
        meta: { title: 'Manual Pegawai' },
      },
      {
        path: 'manualpengguna',
        component: () => import('@/views/mydiesel/blank_diesel'),
        meta: { title: 'Manual Pengguna' },
      },
    ],
    branch: true
  },
  // {
  //   path: '/z/:branchId/mydiesel/testing',
  //   component: Layout,
  //   redirect: '',
  //   name: 'TESTING',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'TESTING' },
  //   children: [
  //     {
  //       path: 'testingssmcompanies',
  //       component: () => import('@/views/mydiesel/testingssmcompanies_diesel'),
  //       meta: { title: 'SSM Companies' },
  //     },
  //     {
  //       path: 'testingjpjcompanies',
  //       component: () => import('@/views/mydiesel/testingjpjcompanies_diesel'),
  //       meta: { title: 'JPJ Companies' },
  //     },
  //     {
  //       path: 'testingjpjvehicles',
  //       component: () => import('@/views/mydiesel/testingjpjvehicles_diesel'),
  //       meta: { title: 'JPJ Vehicles' },
  //     },
  //     {
  //       path: 'testingmyidentityindividuals',
  //       component: () => import('@/views/mydiesel/testingmyidentityindividuals_diesel'),
  //       meta: { title: 'myIDENTITY Individuals' },
  //     },
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/mydiesel/halamanutama',
    component: Layout,
    redirect: '',
    name: 'Halaman Utama',
    meta: { relationRoles: ['oilcompanyuser'], feature: 'mydiesel', title: 'MyDiesel' },
    children: [
      {
        path: '',
        component: () => import('@/views/mydiesel/halamanutamaoilcompany_diesel'),
        meta: { title: 'Halaman Utama' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel',
    component: Layout,
    redirect: '',
    name: 'Fleet Card',
    meta: { relationRoles: ['oilcompanyuser'], feature: 'mydiesel', title: 'Fleet Card' },
    children: [
      {
        path: 'pemegangakaun',
        component: () => import('@/views/mydiesel/pemegangakaunoilcompany_diesel'),
        meta: { title: 'Pemegang Akaun' }
      },
      {
        path: 'physicalfleetcard',
        component: () => import('@/views/mydiesel/physicalfleetcardoilcompany_diesel'),
        meta: { title: 'Senarai Fleet Card' }
      },
      {
        path: 'permohonanpertukaransyarikatminyak',
        component: () => import('@/views/mydiesel/permohonanpertukaransyarikatminyakoilcompany_diesel'),
        meta: { title: 'Permohonan Pertukaran Syarikat Minyak' }
      },
    ],
    noCollapse: true,
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/rekodpenggunaan',
    component: Layout,
    redirect: '',
    name: 'Laporan',
    meta: { relationRoles: ['oilcompanyuser'], feature: 'mydiesel', title: 'Laporan' },
    children: [
      // {
      //   path: 'rekodpenggunaan',
      //   component: () => import('@/views/mydiesel/rekodpenggunaanoilcompany'),
      //   meta: { title: 'Rekod Penggunaan' }
      // },
      {
        path: 'detailrekodpenggunaanoilcompany',
        component: () => import('@/views/mydiesel/detailrekodpenggunaanoilcompany'),
        meta: { title: 'Laporan Penggunaan Kuota' }
      },
      {
        path: 'detailmonthquotaoilcompany',
        component: () => import('@/views/mydiesel/detailmonthquotaoilcompany'),
        meta: { title: 'Laporan Pemegang Akaun' }
      },
      {
        path: 'kuotatambahan',
        component: () => import('@/views/mydiesel/kuotatambahanoilcompany_diesel'),
        meta: { title: 'Laporan Kuota Tambahan' }
      },
      // {
      //   path: 'percentagechangesoilcompany',
      //   component: () => import('@/views/mydiesel/percentagechangesoilcompany'),
      //   meta: { title: 'Laporan Perubahan Kuota' }
      // },
    ],
    noCollapse: true,
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/sekatan',
    component: Layout,
    redirect: '',
    name: 'Sekatan',
    meta: { relationRoles: ['oilcompanyuser'], feature: 'mydiesel', title: 'Sekatan' },
    children: [
      {
        path: 'senaraisekatan',
        component: () => import('@/views/mydiesel/senaraisekatanoilcompany_diesel'),
        meta: { title: 'Senarai Sekatan' }
      },
    ],
    noCollapse: true,
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/banner',
    component: Layout,
    redirect: '',
    name: 'Senarai Banner',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'Banner' },
    children: [
      {
        path: 'senaraibanner',
        component: () => import('@/views/mydiesel/senaraibanner_diesel'),
        meta: { title: 'Senarai Banner' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/sekatan',
    component: Layout,
    redirect: '',
    name: 'Sekatan',
    meta: { relationRoles: ['enforcer'], feature: 'mydiesel', title: 'Sekatan' },
    children: [
      {
        path: 'senaraisekatan',
        component: () => import('@/views/mydiesel/senaraisekatanpenguatkuasa_diesel'),
        meta: { title: 'Senarai Sekatan' }
      },
    ],
    noCollapse: true,
    alwaysShow: true,
    branch: true
  },

  /*   ========  ========  ======== */
  /*  ======== EXTRA PART 1 ======== */
  /* ========  ========  ======== */
  // default - has branch
  // {
  //   path: '/z/:branchId/branch',
  //   component: Layout,
  //   redirect: 'profile',
  //   name: 'Co. Settings',
  //   meta: { title: 'Co. Settings' },
  //   children: [
  //     {
  //       path: 'profile',
  //       component: () => import('@/views/settings/branch/profile'),
  //       meta: { title: 'Profile' }
  //     },
  //     {
  //       path: 'email',
  //       component: () => import('@/views/settings/branch/email'),
  //       meta: { title: 'Email' }
  //     },
  //     {
  //       path: 'collaborator',
  //       component: () => import('@/views/settings/branch/collaborator'),
  //       meta: { title: 'Collaborator' }
  //     }
  //   ],
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/account',
  //   component: Layout,
  //   redirect: 'profile',
  //   name: 'User Settings',
  //   meta: { title: 'User Settings' },
  //   children: [
  //     {
  //       path: 'profile',
  //       component: () => import('@/views/settings/user/profile'),
  //       meta: { title: 'Profile' }
  //     },
  //     {
  //       path: 'password',
  //       component: () => import('@/views/settings/user/password'),
  //       meta: { title: 'Password' }
  //     }
  //   ],
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/branches',
  //   component: Layout,
  //   redirect: 'branches',
  //   name: 'Branches',
  //   meta: { title: 'Branches' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/admin/companies/index'),
  //       meta: { title: 'Branches' }
  //     }
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/default',
    component: Layout,
    redirect: '',
    name: 'Default',
    meta: { title: 'Default' },
    children: [
      {
        path: '',
        component: () => import('@/views/admin/default/index'),
        meta: { title: 'Default' }
      }
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/mysubsidi/overview',
    component: Layout,
    redirect: '',
    name: 'MySubsidi',
    meta: { title: 'Overview', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/home/overview'),
        meta: { title: 'MySubsidi', icon: 'ow_clock1' }
      }
    ],
    hidden: true
  },

  /*   ========  ========  ======== */
  /*  ======== EXTRA PART 2 ======== */
  /* ========  ========  ======== */
  // default - no branch
  // {
  //   path: '/branch',
  //   component: Layout,
  //   redirect: 'profile',
  //   name: 'Co. Settings',
  //   meta: { title: 'Co. Settings' },
  //   children: [
  //     {
  //       path: 'profile',
  //       component: () => import('@/views/settings/branch/profile'),
  //       meta: { title: 'Profile' }
  //     },
  //     {
  //       path: 'email',
  //       component: () => import('@/views/settings/branch/email'),
  //       meta: { title: 'Email' }
  //     },
  //     {
  //       path: 'collaborator',
  //       component: () => import('@/views/settings/branch/collaborator'),
  //       meta: { title: 'Collaborator' }
  //     }
  //   ]
  // },
  // {
  //   path: '/account',
  //   component: Layout,
  //   redirect: 'profile',
  //   name: 'User Settings',
  //   meta: { title: 'User Settings' },
  //   children: [
  //     {
  //       path: 'profile',
  //       component: () => import('@/views/settings/user/profile'),
  //       meta: { title: 'Profile' }
  //     },
  //     {
  //       path: 'password',
  //       component: () => import('@/views/settings/user/password'),
  //       meta: { title: 'Password' }
  //     }
  //   ]
  // },
  // {
  //   path: '/email',
  //   component: Layout,
  //   redirect: 'email',
  //   name: 'Email',
  //   meta: { title: 'Email' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/email/index'),
  //       meta: { title: 'Email' }
  //     }
  //   ],
  //   branch: false
  // },
  // {
  //   path: '/branches',
  //   component: Layout,
  //   redirect: 'branches',
  //   name: 'Branches',
  //   meta: { title: 'Branches' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/admin/companies/index'),
  //       meta: { title: 'Branches' }
  //     }
  //   ],
  //   branch: false
  // },
  // {
  //   path: '/dashboard',
  //   component: Layout,
  //   redirect: 'dashboard',
  //   name: 'Dashboard',
  //   meta: { title: 'Dashboard' },
  //   children: [{
  //     path: '',
  //     component: () => import('@/views/admin/dashboard/index'),
  //     meta: { title: 'Dashboard', icon: 'el-icon-monitor' }
  //   },
  //   {
  //     path: 'instance',
  //     component: () => import('@/views/admin/dashboard/index'),
  //     name: 'New Instance',
  //     meta: { title: 'New Instance' },
  //     hidden: true
  //   }]
  // },
  {
    path: '/users',
    component: Layout,
    redirect: 'users',
    name: 'Users',
    meta: { roles: ['generalmanager'], title: 'Users' },
    children: [{
      path: '',
      component: () => import('@/views/admin/users/index'),
      meta: { title: 'Users' }
    }]
  }
  // { path: '*', redirect: '/404', hidden: true }
]



// WEBPACK FOOTER //
// ./src/router/index.js